module.exports = __webpack_public_path__ + "static/media/anillo-derecha.b227fed4.png";